<template>
  <v-layout row>
    <v-flex xs9>
      <v-img v-if="pictureUrl !== null" class="education-image" width="225px" height="100px" :src="pictureUrl"></v-img>
      <div v-else style="height: 100px"></div>
    </v-flex>
    <v-flex xs3 class="text-xs-right">
      <v-btn color="success" @click="open">
        {{ 'app.education.image_add' | trans }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'education-picture',
  props: {
    url: null,
  },
  methods: {
    open() {
      this.$emit('addImage');
    },
  },
  computed: {
    pictureUrl() {
      if (this.url === null) {
        return null;
      }

      return `/photos/education/${this.url}`;
    },
    rules: function () {
      return {};
    },
  },
};
</script>

<style scoped>
</style>
